module.exports = __webpack_public_path__ + "img/eric-thomsen.2f4f5566.jpg";